import { Pipe, PipeTransform } from '@angular/core';

/**
 * Generic order by pipe to sort any array by the given key
 */
@Pipe({
    name: "orderBy"
})

export class OrderByPipe implements PipeTransform {
    transform(array: Array<any>, orderBy: string): any[] {
        if(!array || array.length <= 0) return [];

        // Check direction of sort (sort key starts with ! on descending sort)
        let reversOrder = false;
        if(orderBy.charAt(0) == "!") {
            // desc sort order
            reversOrder = true;
            // remove fist char
            orderBy = orderBy.substring(1, orderBy.length);
        }
        // Test first element to see if we should use string compare or numeric compare
        let sortAsString = typeof array[0][orderBy] == 'string';
        array.sort((a, b) => {
            return (sortAsString) ? this.compareStr(a, b, orderBy) : this.compareNum(a, b, orderBy);
        });

        // Obs: We need to slice it in order for angular change detacition to detect the change
        return (reversOrder) ? array.reverse().slice() : array.slice();
    }

    private compareStr(a: any, b: any, orderBy: string): number {
        if(!a[orderBy]) {
            console.warn(`Cannot sort by '${orderBy}', key does not exist on object`, a);
            return -1;
        }
        return a[orderBy].localeCompare(b[orderBy]);
    }

    private compareNum(a: any, b: any, orderBy: string): number {
        if(!a[orderBy]) {
            console.warn(`Cannot sort by '${orderBy}', key does not exist on object`, a);
            return -1;
        }
        return a[orderBy] - b[orderBy];
    }
}
